import { ViewsType } from '@typesSrc/views';
import BaseView from '@views/base-view';
import React from 'react';
import Search1v1Opponent from '@components/challenge/search-1v1-opponent';
export default function SearchPlayerView() {
    return (React.createElement(BaseView, { view: ViewsType.CHALLENGE_SEARCH_PLAYER, header: { title: 'Spieler/-in wählen', showBack: true }, showFooter: false },
        React.createElement(Search1v1Opponent, null)));
}
